var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"m-2 p-2",class:this.settings.class,style:(this.settings.style),attrs:{"src":this.settings.src,"width":"80%","height":"800vh"}})
}
var staticRenderFns = []

export { render, staticRenderFns }